import { GetStaticPropsContext } from "next";
import { FooterProps, getFooterProps } from "@lib/models/layout/footer";
import { HeaderProps } from "@lib/header";
import { SEOProps, compileDefaultSEOInformation } from "./seo";
import { CookieBannerDTO } from "@lib/strapi/dtos/content-types/cookieBanner.dto";
import { fetchGoogleReviews } from "@lib/frontend/google-reviews";
import { CookieBannerService } from "@lib/strapi/services/content-types/cookieBanner.service";

// index signature (snb BasePageProps): page props must satisfy Next's
// GetServerSideProps `{ [key: string]: unknown }` constraint
export interface BasePageProps { [key: string]: unknown }

export interface BaseProps extends BasePageProps {
  seo: SEOProps;
  header: HeaderProps;
  footer: FooterProps;
  cookieBanner?: CookieBannerDTO | null;
  /** live Google aggregate for chrome-level UI (search overlay) — TTL-cached */
  googleReviews?: import("@lib/frontend/google-reviews").GoogleReviewsData | null;
  preview?: boolean;
}

export const getBaseProps = async (
  context: GetStaticPropsContext,
  header: HeaderProps
): Promise<BaseProps> => {
  // parallel: three independent fetches, and this runs once per page per
  // locale at build time — sequential awaits were pure added build latency
  const [seo, footer, cookieBanner, googleReviews] = await Promise.all([
    compileDefaultSEOInformation(context, { pageTitle: "" }),
    getFooterProps(context),
    CookieBannerService.fetchSingle(null, context.locale ?? "el"),
    fetchGoogleReviews(context.locale ?? "el"),
  ]);

  return { seo, header, footer, cookieBanner, googleReviews, preview: context.preview };
};
